import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import { callbackKind } from "./callbackKind";

/** GAVION skip-callback: « Demandé » (the person asked) or « Auto » (automatic follow-up) next to a callback. */
export const CallbackKindBadge = ({
  lastCallOutcome,
}: {
  lastCallOutcome: string | null | undefined;
}) => {
  const t = useTranslate();
  const kind = callbackKind(lastCallOutcome);
  return (
    <Badge
      variant={kind === "requested" ? "default" : "outline"}
      title={t(`gavion.callbacks.kind.${kind}_hint`)}
      data-callback-kind={kind}
    >
      {t(`gavion.callbacks.kind.${kind}`)}
    </Badge>
  );
};
